import { Component, Inject } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'app-interfaces-create-token-dialog',
    templateUrl: './interfaces-create-token-dialog.component.html',
    styleUrls: ['./interfaces-create-token-dialog.component.css'],
    standalone: false
})
export class InterfacesCreateTokenDialogComponent {
  tokenForm!:FormGroup
  tokenDisplayName:any
  type:any

  constructor(
    public dialogRef: MatDialogRef<InterfacesCreateTokenDialogComponent>,
    private fb: FormBuilder,
    public dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ){
    dialogRef.disableClose = true;
  }

  ngOnInit(){
    this.type = this.data['type']
    
    this.tokenForm = this.fb.group({
      displayName:[]
    })
  }

  dialogCancel(){
    this.dialogRef.close([false, this.tokenDisplayName])

  }
  dialogSave(){
    const data = this.tokenForm.value
    this.dialogRef.close([true, data])
  }
}